import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { routeCreator as campaignRouteCreator } from '@occc-app/routes/Campaign/utils';

export const useNavigateToCampaign = (campaignId: string) => {
  const navigate = useNavigate();

  return useCallback(
    () => navigate(campaignRouteCreator.details(campaignId)),
    [navigate, campaignId],
  );
};
